import {useRef} from "react";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import {Button, Card, Form, Input, notification} from "antd";
import {useUser} from "../Context/UserContext";
import ApiService from "../Service/ApiService";

export default function ChangePassword() {
    const form = useRef();
    const {signOut} = useUser()

    const onFinish = async () => {
        const data = form.current.getFieldsValue();
        if(data) {
            const res = await ApiService.User.ChangePassword({
                ...data
            });

            if(res.success) {
                notification.success({
                    message: 'Your password was changed successfully.',
                    duration: 3
                })
                signOut()
            }
        }
    }

    return (
        <>
            <Form
                layout={'vertical'}
                ref={form}
                onFinish={onFinish}
            >
                <Form.Item
                    rules={[
                        {required: true}
                    ]}
                    name={'password'}
                    label={'Password'}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    name="newPassword"
                    label="New Password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                    ]}
                    hasFeedback
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    name="confirmPassword"
                    label="Confirm Password"
                    dependencies={['newPassword']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Button htmlType={'submit'} type={'primary'}>
                    Change
                </Button>
            </Form>
        </>
    )
}